export const baseStyles = `
.feedback-widget,
.liveChat-widget,
.changelog-widget,
.feedback-survey,
.feedback-panel,
.feedback-modal,
.changelog-modal,
.changelog-list-modal,
.product7-notification {
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', Oxygen, Ubuntu, Cantarell, sans-serif;
}

.feedback-widget *,
.feedback-widget *::before,
.feedback-widget *::after,
.liveChat-widget *,
.liveChat-widget *::before,
.liveChat-widget *::after,
.changelog-widget *,
.changelog-widget *::before,
.changelog-widget *::after,
.feedback-survey *,
.feedback-survey *::before,
.feedback-survey *::after,
.feedback-panel *,
.feedback-panel *::before,
.feedback-panel *::after,
.feedback-modal *,
.feedback-modal *::before,
.feedback-modal *::after,
.changelog-modal *,
.changelog-modal *::before,
.changelog-modal *::after,
.changelog-list-modal *,
.changelog-list-modal *::before,
.changelog-list-modal *::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: reduce) {
  .feedback-widget *,
  .liveChat-widget *,
  .changelog-widget *,
  .feedback-survey * {
    transition: none !important;
    animation: none !important;
  }
}

@media print {
  .feedback-widget,
  .feedback-panel,
  .sdk-modal-backdrop,
  .sdk-notification,
  .changelog-widget,
  .changelog-modal,
  .liveChat-widget,
  .liveChat-launcher,
  .liveChat-panel,
  .feedback-survey,
  .feedback-survey-backdrop {
    display: none !important;
  }
}
`;
